import React from 'react';
import { Redirect, Route } from 'react-router';

import AdsPage              from 'containers/AdsPage';
import AggregateData        from 'containers/AggregateData';
import AlgorithmPage        from 'containers/AlgorithmPage';
import App                  from 'containers/App';
import DownloadPage         from 'containers/DownloadPage';
import LoginPage            from 'containers/Auth/LoginPage';
import LogoutPage           from 'containers/Auth/LogoutPage';
import NotificationsPage    from 'containers/NotificationsPage';
import PricesPage           from 'containers/PricesPage';
import ReferralCodesPage    from 'containers/ReferralCodesPage';
import ResetPasswordPage    from 'containers/Auth/ResetPasswordPage';
import UsersPage            from 'containers/UsersPage';

import { LOCALSTORAGE } from 'utils/constants';

const requireAuth = (nextState, replace) => {
    //return true;
    if(localStorage.getItem(LOCALSTORAGE.ID_TOKEN) == null) {
        replace({pathname: '/login'})
    }
};

const Routes = (
    <Route path="/"                                             component={App}>
        <Route                  path="ads"                      component={AdsPage}                 onEnter={requireAuth} />
        <Route                  path="data"                     component={AggregateData}           onEnter={requireAuth} />
        <Route                  path="algorithm"                component={AlgorithmPage}           onEnter={requireAuth} />
        <Route                  path="download"                 component={DownloadPage}            onEnter={requireAuth} />
        <Route                  path="login"                    component={LoginPage} />
        <Route                  path="logout"                   component={LogoutPage} />
        <Route                  path="notifications"            component={NotificationsPage}       onEnter={requireAuth} />
        <Route                  path="reset-password"    component={ResetPasswordPage} />
        <Route                  path="prices"                   component={PricesPage}              onEnter={requireAuth} />
        <Route                  path="referral-codes"           component={ReferralCodesPage}       onEnter={requireAuth} />
        <Route                  path="users"                    component={UsersPage}               onEnter={requireAuth} />
        <Redirect from="*" to="/download" />
    </Route>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/Root/Routes.js